// Module 100 % pur — statuts opérationnels T1 + matrice transitions data canon W.9.
// Aucune dépendance vers `src/db/` (sauf type) ni vers `src/features/` : ce module
// est partagé entre data layer (`src/db/transactions.ts`) et UI gate (futur
// `useT1ActionGate` sous-ticket 4). Réutilisable sans IndexedDB ni navigateur.
//
// Source unique de vérité = constante `MATRICE_TRANSITIONS_W9` ci-dessous.
// Le graphe est un graphe data autonome (cf. spec sous-ticket 1 v1.0.1 §6.3.3,
// durcissement ChatGPT R1) — il n'est PAS dérivé de la matrice actions UI T1
// doctrine W.9 §4 qui régit l'autorisation UI à un niveau distinct.

import type { StatutCommande } from '../db/schema';

// Liste canonique des 8 statuts data persistés (cf. spec §6.3.4 + commentaire schema.ts).
// Ordre = ordre logique opérationnel doctrine W.9 §3 (hors Brouillon UI transient).
export const STATUTS_DATA: readonly StatutCommande[] = [
  'commandee',
  'priorisee',
  'en_preparation',
  'enfournee',
  'en_finalisation',
  'prete',
  'cloturee',
  'annulee',
] as const;

// Graphe data explicite des transitions de statut autorisées au niveau data layer.
// Source unique de vérité figée — toute modification nécessite un ticket dédié
// (cf. doctrine TECH-DESIGN-FIRST OS §13). Statuts terminaux verrouillés (aucun outbound).
//
// Note : `en_finalisation` est une transition technique courte entre `enfournee` et
// `prete` (cf. brief MVP §4.1 « événement fantôme »). Outbound unique = `prete`.
export const MATRICE_TRANSITIONS_W9: Record<
  StatutCommande,
  readonly StatutCommande[]
> = {
  commandee: ['priorisee', 'annulee'],
  priorisee: ['en_preparation', 'annulee'],
  en_preparation: ['enfournee', 'annulee'],
  enfournee: ['en_finalisation', 'annulee'],
  en_finalisation: ['prete'],
  prete: ['cloturee', 'annulee'],
  cloturee: [],
  annulee: [],
} as const;

// Pure function : retourne `true` si la transition `de -> vers` est autorisée par
// la matrice canonique. Statuts terminaux (`cloturee`, `annulee`) retournent toujours
// `false` quelle que soit la cible — verrouillage explicite.
export function peutTransiterVers(
  de: StatutCommande,
  vers: StatutCommande,
): boolean {
  return MATRICE_TRANSITIONS_W9[de].includes(vers);
}

// Pure function : retourne la liste des cibles autorisées depuis un statut donné.
// Pour les statuts terminaux, retourne un tableau vide.
export function transitionsAutoriseesDepuis(
  statut: StatutCommande,
): readonly StatutCommande[] {
  return MATRICE_TRANSITIONS_W9[statut];
}
